import BWDataService from 'src/services/bw-data.service';

export interface ResetUserPayload {
    isTypeFull: boolean;
    isTypeBudgeting: boolean;
    email: string;
    snapshot?: string;
    onboardingStep?: string;
    termsVersion?: number | '';
    deleteUser?: boolean;
}

export type AdminSyncStatus = 'idle' | 'syncing' | 'try_again_later' | 'account_not_found' | 'plaid_internal_error';
export interface SetSyncStatusPayload {
    accounts: Array<{
        id: number;
        status: AdminSyncStatus;
    }>;
}

/**
 * FOR TESTING PURPOSES ONLY
 *
 * Service that powers the admin tool. Provides requests for setting users
 * to a specific snapshot or setting user accounts to errored states.
 */
export default class AdminService extends BWDataService {
    /**
     * FOR TESTING PURPOSES ONLY:
     * Reset data of the current user to match the provided details/snapshot
     */
    public static async resetUser(user: ResetUserPayload): Promise<any> {
        try {
            const payload: ResetUserPayload = {
                isTypeFull: user.isTypeFull,
                isTypeBudgeting: user.isTypeBudgeting,
                email: user.email,
                onboardingStep: user.onboardingStep || undefined,
                snapshot: !user.snapshot || user.snapshot === 'delete_user' ? undefined : user.snapshot,
                deleteUser: user.deleteUser || undefined,
                termsVersion: user.termsVersion === '' ? undefined : user.termsVersion
            };

            await this.post('/snapshot/admin', payload);

            await BWDataService.logoutUser();
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * FOR TESTING PURPOSES ONLY:
     * Manually set accounts to certain sync statuses
     */
    public static async setSyncStatus(payload: SetSyncStatusPayload): Promise<void> {
        const filteredAccounts = payload.accounts.filter(({ status }) => status !== null);
        try {
            console.log(filteredAccounts);
            await this.post('/snapshot/admin/set_sync_status', filteredAccounts);
        } catch (e) {
            console.error(e);
        }
    }

    public static async forceHideUnhideAccounts(): Promise<any> {
        return await this.post('/snapshot/admin/hide_unhide_accounts', {});
    }
}
